<template>
    <!--新增界面-->
    <div v-if="formVisible">
        <el-dialog v-dragDialog :title="formTitle" :visible.sync="formVisible" width="500px"
            :close-on-click-modal="false">
            <el-form :model="addForm" ref="dataForm" label-width="110px" :rules="formRules">
                <el-form-item label="中奖人:" prop="Member">
                    <customerSelector ref="customerSelector" v-model="addForm.Member" />
                </el-form-item>
                <el-form-item label="身份证号:" prop="Member.IdCode">
                    <el-input v-model="addForm.Member.IdCode" auto-complete="off" placeholder="请输入身份证号"></el-input>
                </el-form-item>
                <el-form-item label="中奖奖品:" prop="Award">
                    <awardSelector ref="awardSelector" v-model="addForm.Award" />
                </el-form-item>
                <el-form-item label="中奖时间:" prop="WinningDate">
                    <el-date-picker v-model="addForm.WinningDate" type="date" size="small" placeholder="请选择中奖时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="是否已兑奖:" prop="IsRedeem">
                    <el-switch v-model="addForm.IsRedeem" />
                </el-form-item>
                <el-form-item v-if="addForm.IsRedeem" label="兑奖日期:" prop="RedeemDate">
                    <el-date-picker v-model="addForm.RedeemDate" type="date" size="small" placeholder="请选择兑奖日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="备注:" prop="Description">
                    <el-input v-model="addForm.Description" type="textarea" :rows="6" auto-complete="off"
                        placeholder="请输入备注"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="formVisible = false">取消</el-button>
                <el-button type="primary" @click="handleSubmit">提交</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { save } from "@/api/activity/memberAward";
import customerSelector from "@/components/customerSelector";
import awardSelector from "./awardSelector";
export default {
    components: {
        customerSelector,
        awardSelector
    },
    data() {
        return {
            formVisible: false,
            fromTitle: "添加奖品",
            addForm: {},
            formRules: {
                Member: [{ required: true, message: "请选择中奖人", trigger: "change" }],
                Award: [{ required: true, message: "请选择奖品", trigger: "change" }],
                WinningDate: [{ required: true, message: "请选择中奖时间", trigger: "change" }],
            },
        };
    },
    methods: {
        handleCreate() {
            this.formTitle = "添加中奖信息";
            this.formVisible = true;
            this.addForm = {
                Member: "",
                Award: "",
                WinningDate: "",
                IsRedeem: false,
                RedeemDate: null,
                Description: "",
            };
            this.$nextTick(() => {
                this.$refs["dataForm"].clearValidate();
            });
        },
        handleUpdate(row) {
            this.addForm = JSON.parse(JSON.stringify(row));
            this.addForm.WinningDate = this.format.dateFormat(row.WinningDate);
            this.addForm.RedeemDate = this.format.dateFormat(row.RedeemDate);
            this.formTitle = "修改中奖信息";
            this.formVisible = true;
            this.$nextTick(() => {
                this.$refs["dataForm"].clearValidate();
            });
        },
        handleSubmit() {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    let para = Object.assign(this.addForm);
                    this.$confirm("确认提交吗？", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                    }).then(() => {
                        save(para).then((response) => {
                            if (response) {
                                this.formVisible = false;
                                this.$emit("update")
                            }
                        });
                    });
                }
            });
        },
        // customerChanged(v) {
        //     this.addForm.Member = v;
        // },
    },
    mounted() {
    },
};
</script>